import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./Inquiry.module.css";
import "../../fonts/Futura-PT-Book.ttf";
import { Link } from "react-router-dom";
const Inquiry = () => {
  return (
    <div>
      <Header />
      <div className={styles.Inquiry}>
        <div className="mb-4">
          <h6 className={styles.firstTitle}>Contact form</h6>
          <h6 className={styles.secondTitle}>お問い合わせ</h6>
        </div>
        <p className="py-3">
          <span className={styles.secondText}>
            ご不明点がございましたら、お気軽にお問い合わせください。
            また、よくいただく質問をまとめておりますので、お問い合わせ前にご確認くださいませ。
          </span>
          <br />
          <Link
            to={"/faq"}
            style={{ textDecorationLine: "underline", color: "#5592D0" }}
          >
            よくある質問
          </Link>
          <br /> <br />
          <span className={styles.secondText}>
            ID(登録時のメールアドレス)が不明な場合や、誤ったメールアドレスを登録してしまった場合は、こちらからお問い合わせください。
          </span>
        </p>
        <form action="">
          <div className={styles.threeForm}>
            <InputWithHeader heading="お名前" placeholder="今川　花子" />
            <InputWithHeader
              heading="お名前(お名前(カナ"
              placeholder="お名前(イマガワ　ハナコ"
            />
            <InputWithHeader
              heading="メールアドレス"
              placeholder="例）sample111@gmail.com"
            />
            <InputWithHeader heading="電話番号" placeholder="09012345678" />
            <div>
              <h6 className={styles.lbl}>お問い合わせ内容</h6>
              <textarea
                className={`${styles.textarea} p-4`}
                placeholder="例）ログインIDが分からなくなったので教えてください。"
              ></textarea>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <div>
              <input className={styles.check} type="checkbox" disabled />
            </div>

            <h6 className={styles.endTitle}>
              上記内容に間違いかを確認してチェックを入れてください。
            </h6>
          </div>
          <div className={styles.sendDiv}>
            <h6 className={styles.send}>Send</h6>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

const InputWithHeader = ({ heading, placeholder }) => {
  return (
    <div className="my-4">
      <h6 className={styles.lbl}>{heading}</h6>
      <input
        className={styles.firstInput}
        type="text"
        placeholder={placeholder}
      />
    </div>
  );
};

export default Inquiry;
